import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatPhoneNumber'
})
export class FormatPhoneNumberPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return value;

    // Remove non-numeric characters
    const cleaned = value.replace(/[^\d]/g, '');

    // Get the last 10 digits
    const lastTen = cleaned.slice(-10);

    // Format the last 10 digits
    const formatted = lastTen.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');

    return formatted;
  }
}
